import type { AuthProviderProps } from "react-oidc-context";

export const oidcConfig: AuthProviderProps = {
  authority: "https://cognito-idp.eu-south-1.amazonaws.com/eu-south-1_q0RPmSSf1",
  client_id: "6n8s16dbgt3og98ck6a31s0b80",
  redirect_uri: window.location.origin + "/callback",
  response_type: "code",
  scope: "email openid profile aws.cognito.signin.user.admin",
};
